module.exports = __webpack_public_path__ + "img/kulturamt-white.ca4dd344.svg";